/* KÒRMESIC theme · shared behaviour (ported from the Concept 5 mockup's site.js).
   Cart uses Shopify's Ajax Cart API; the wishlist is per-browser (localStorage) until a wishlist app is chosen. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var CFG = window.KM_CFG || { routes: {}, freeShip: 5000, money: '${{amount}}' };
  var R = CFG.routes;
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var KM = window.KM = window.KM || {};
  var esc = function (s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };

  /* ---------- money (Shopify money_format) ---------- */
  KM.money = function (cents) {
    cents = Math.round(+cents || 0);
    var fmt = CFG.money || '${{amount}}';
    function group(n, d, ts, ds) {
      var p = (n / 100).toFixed(d).split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts) + (p[1] ? ds + p[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return group(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return group(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return group(cents, 0, '.', ',');
      return group(cents, 2, ',', '.');
    });
  };
  var money = KM.money;

  /* ---------- storage ---------- */
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) { } }
  };
  var wish = store.get('km_wish', []);
  KM.wish = function () { return wish.slice(); };

  /* ---------- toast + fly-to-bag ---------- */
  var toastT;
  KM.toast = function (msg, label, fn) {
    var t = $('#toast'); if (!t) return;
    t.innerHTML = '<span><b class="ok">✓</b> ' + msg + '</span>' + (label ? '<button type="button">' + label + '</button>' : '');
    if (label) $('button', t).onclick = function () { t.classList.remove('on'); fn(); };
    t.classList.add('on'); clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('on'); }, 3200);
  };
  function bagTarget() { var all = $$('[data-bag]'); for (var i = 0; i < all.length; i++) if (all[i].offsetParent !== null) return all[i]; return all[0]; }
  function fly(from, src) {
    var to = bagTarget(); if (reduce || !to || !src || !from.getBoundingClientRect) return;
    var a = from.getBoundingClientRect(), b = to.getBoundingClientRect(), el = document.createElement('img');
    el.className = 'fly'; el.src = src; el.alt = ''; el.style.left = (a.left + a.width / 2 - 27) + 'px'; el.style.top = (a.top - 20) + 'px';
    document.body.appendChild(el);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + 7);
    el.animate([{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: 'translate(' + dx * .5 + 'px,' + (dy * .5 - 60) + 'px) scale(.8)', opacity: 1, offset: .5 }, { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.15)', opacity: .3 }], { duration: 700, easing: 'cubic-bezier(.3,.6,.4,1)' }).onfinish = function () { el.remove(); };
  }

  /* ---------- panels ---------- */
  var openEl = null;
  function openPanel(name) {
    closePanel(true);
    var el = $('#panel-' + name); if (!el) return;
    openEl = el; el.classList.add('on'); el.setAttribute('aria-hidden', 'false');
    var s = $('#scrim'); if (s) s.classList.add('on');
    document.documentElement.classList.add('lock');
    var hdr = $('#hdr'); if (hdr) hdr.classList.remove('hide');
    $$('img[data-src]', el).forEach(function (im) { im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); });
    if (name === 'search') setTimeout(function () { var i = $('#q'); if (i) i.focus(); }, 60);
    var f = $('[data-close]', el); if (f && name !== 'search') setTimeout(function () { f.focus(); }, 60);
  }
  function closePanel(keep) {
    if (openEl) { openEl.classList.remove('on'); openEl.setAttribute('aria-hidden', 'true'); openEl = null; }
    if (!keep) { var s = $('#scrim'); if (s) s.classList.remove('on'); document.documentElement.classList.remove('lock'); }
  }
  KM.open = openPanel; KM.close = closePanel;

  /* ---------- cart (Ajax API) ---------- */
  var cart = window.KM_CART || { items: [], item_count: 0, total_price: 0 };
  var subs = [];
  KM.onCart = function (fn) { subs.push(fn); };
  KM.cart = function () { return cart; };
  function api(url, body) {
    return fetch(url, { method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function refresh() { return api(R.cart + '.js').then(setCart); }
  function setCart(c) { cart = c; paintCounts(); renderCart(); subs.forEach(function (f) { f(cart); }); return c; }
  KM.add = function (items) { return api(R.cartAdd + '.js', { items: items }).then(refresh); };
  KM.change = function (key, qty) { return api(R.cartChange + '.js', { id: key, quantity: qty }).then(setCart); };

  function paintCounts() {
    var n = cart.item_count || 0;
    $$('[data-cart-count]').forEach(function (c) { var was = c.textContent; c.textContent = n; c.setAttribute('data-n', n); if (String(n) !== was) { c.classList.add('bump'); setTimeout(function () { c.classList.remove('bump'); }, 350); } });
    $$('[data-wish-count]').forEach(function (c) { c.textContent = wish.length; c.setAttribute('data-n', wish.length); });
  }
  function shipBar(sub) {
    var free = CFG.freeShip, left = free - sub, pct = Math.min(100, sub / free * 100);
    return '<div class="ship' + (left <= 0 ? ' done' : '') + '">' + (left > 0 ? 'You are <b>' + money(left) + '</b> away from free shipping' : '<b>✓ Free shipping unlocked</b>') + '<div class="bar"><i style="width:' + pct + '%"></i></div></div>';
  }
  KM.shipBar = shipBar;
  function img(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  KM.lineHTML = function (x) {
    var opts = (x.options_with_values || []).filter(function (o) { return o.value !== 'Default Title'; }).map(function (o) { return o.value; });
    var plan = x.selling_plan_allocation ? x.selling_plan_allocation.selling_plan.name : '';
    var meta = [x.product_type].concat(opts).filter(Boolean).join(' · ') + (plan ? '<br>' + esc(plan) : '');
    var was = x.original_line_price > x.final_line_price ? '<s class="muted small" style="margin-right:6px">' + money(x.original_line_price) + '</s>' : '';
    return '<div class="line"><a href="' + x.url + '"><img src="' + img(x.image, 160) + '" alt="" width="76" height="76"></a><div><a class="l-name" href="' + x.url + '">' + esc(x.product_title) + '</a><div class="l-meta">' + meta + '</div>' +
      '<div class="l-row"><div class="qty"><button type="button" data-qty="' + x.key + '" data-q="' + (x.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + x.quantity + '</span><button type="button" data-qty="' + x.key + '" data-q="' + (x.quantity + 1) + '" aria-label="Increase quantity">+</button></div><span class="l-price">' + was + money(x.final_line_price) + '</span></div>' +
      '<button type="button" class="l-rm" data-qty="' + x.key + '" data-q="0">Remove</button></div></div>';
  };
  function discountsHTML(c) {
    return (c.cart_level_discount_applications || []).map(function (d) { return '<div class="save-row"><span>' + esc(d.title) + '</span><span>−' + money(d.total_allocated_amount) + '</span></div>'; }).join('');
  }
  KM.discountsHTML = discountsHTML;
  function renderCart() {
    var box = $('#cartBody'); if (!box) return;
    var items = cart.items || [];
    $('#cartTitle').textContent = 'Your bag (' + (cart.item_count || 0) + ')';
    if (!items.length) {
      box.innerHTML = $('#cartEmptyTpl') ? $('#cartEmptyTpl').innerHTML : '';
      $('#cartFoot').hidden = true; return;
    }
    var have = items.map(function (x) { return x.product_id; });
    var ups = (window.KM_UPSELL || []).filter(function (p) { return have.indexOf(p.id) < 0 && p.available; }).slice(0, 2);
    box.innerHTML = shipBar(cart.total_price) + items.map(KM.lineHTML).join('') + discountsHTML(cart) +
      (ups.length ? '<div class="upsell"><h3>Goes well with</h3>' + ups.map(function (p) { return '<div class="up"><img src="' + img(p.img, 120) + '" alt="" width="56" height="56"><div><b>' + esc(p.title) + '</b><span>' + money(p.price) + '</span></div><button type="button" class="btn btn-sm" data-add="' + p.variant + '" data-img="' + img(p.img, 120) + '" data-name="' + esc(p.title) + '" data-quiet aria-label="Add ' + esc(p.title) + '">Add</button></div>'; }).join('') + '</div>' : '');
    $('#cartFoot').hidden = false; $('#cartSub').textContent = money(cart.total_price);
  }
  KM.renderCart = renderCart;

  /* ---------- wishlist ---------- */
  function paintHearts() {
    $$('[data-wish]').forEach(function (b) { var on = wish.indexOf(b.dataset.wish) > -1; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on); });
    paintCounts();
  }
  KM.paintHearts = paintHearts;

  /* ---------- predictive search ---------- */
  function initSearch() {
    var out = $('#soOut'), q = $('#q'), def = out ? out.innerHTML : '', timer, ctrl;
    if (!q) return;
    function row(p) {
      var im = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
      var price = Math.round(parseFloat(p.price) * 100);
      return '<a href="' + p.url + '"><img src="' + img(im, 120) + '" alt="" width="56" height="56"><div><b>' + esc(p.title) + '</b><span>' + esc(p.type || '') + '</span></div><em>' + money(price) + '</em></a>';
    }
    function run() {
      var v = q.value.trim();
      if (!v) { out.innerHTML = def; return; }
      if (ctrl) ctrl.abort(); ctrl = window.AbortController ? new AbortController() : null;
      fetch(R.predictive + '.json?q=' + encodeURIComponent(v) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var r = (j.resources && j.resources.results && j.resources.results.products) || [];
          var all = R.search + '?type=product&q=' + encodeURIComponent(v);
          out.innerHTML = r.length ? '<h3>Products for "' + esc(v) + '"</h3><div class="so-res">' + r.map(row).join('') + '</div><a class="btn btn-ink btn-block" href="' + all + '">See all results</a>'
            : '<div class="empty"><h3 class="h3">Nothing for "' + esc(v) + '"</h3><p class="muted small">Check the spelling, or try a category like hair mask or serum.</p></div>';
        }).catch(function () { });
    }
    q.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(run, 180); });
    q.addEventListener('keydown', function (e) { if (e.key === 'Enter' && q.value.trim()) location.href = R.search + '?type=product&q=' + encodeURIComponent(q.value.trim()); });
    KM._term = function (t) { q.value = t; run(); };
  }

  /* ---------- carousels ---------- */
  KM.snap = function (track) {
    var slides = Array.prototype.slice.call(track.children), dots = track.dataset.snap ? document.getElementById(track.dataset.snap) : null, i = 0, timer;
    if (!slides.length) return;
    function go(n) { i = (n + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); }
    if (dots && slides.length > 1) {
      dots.innerHTML = slides.map(function (_, k) { return '<button type="button" aria-label="Go to slide ' + (k + 1) + '"' + (k === 0 ? ' aria-current="true"' : '') + '></button>'; }).join('');
      $$('button', dots).forEach(function (d, k) { d.addEventListener('click', function () { go(k); auto(); }); });
    }
    track.addEventListener('scroll', function () {
      i = Math.min(slides.length - 1, Math.max(0, Math.round(track.scrollLeft / (slides[0].offsetWidth || 1))));
      if (dots) $$('button', dots).forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      track.dispatchEvent(new CustomEvent('km:slide', { detail: i }));
    }, { passive: true });
    function auto() { clearInterval(timer); if (+track.dataset.auto && !reduce && slides.length > 1) timer = setInterval(function () { go(i + 1); }, +track.dataset.auto); }
    var wrap = track.parentElement;
    $$('[data-prev]', wrap).forEach(function (bt) { bt.addEventListener('click', function () { go(i - 1); auto(); }); });
    $$('[data-next]', wrap).forEach(function (bt) { bt.addEventListener('click', function () { go(i + 1); auto(); }); });
    track.addEventListener('pointerdown', function () { clearInterval(timer); });
    track._go = go;
    auto();
  };

  /* ---------- product forms (PDP, quick add, bundles) ---------- */
  function addFromButton(el) {
    var ids = String(el.dataset.add).split(',').filter(Boolean), qty = +(el.dataset.units || 1), plan = el.dataset.plan;
    var items = ids.map(function (id) { var it = { id: +id, quantity: qty }; if (plan) it.selling_plan = +plan; return it; });
    var html = el.innerHTML; el.disabled = true;
    return KM.add(items).then(function () {
      el.disabled = false;
      if (!el.dataset.keep) { el.classList.add('is-done'); el.innerHTML = 'Added ✓'; setTimeout(function () { el.classList.remove('is-done'); el.innerHTML = html; }, 1400); }
      fly(el, el.dataset.img);
      if (el.dataset.quiet !== undefined) return;
      if (el.dataset.drawer !== undefined) setTimeout(function () { openPanel('cart'); }, reduce ? 0 : 450);
      else KM.toast((ids.length > 1 ? ids.length + ' items' : esc(el.dataset.name || 'Item')) + ' added', 'View bag', function () { openPanel('cart'); });
    }).catch(function (err) {
      el.disabled = false; el.innerHTML = html;
      KM.toast(esc((err && (err.description || err.message)) || 'Could not add that item'));
    });
  }

  KM.addFromButton = addFromButton;

  /* ---------- boot ---------- */
  function boot() {
    paintCounts(); renderCart(); paintHearts(); initSearch();

    document.addEventListener('click', function (e) {
      var t = e.target, el;
      if ((el = t.closest('[data-term]'))) { if (KM._term) KM._term(el.dataset.term); return; }
      if ((el = t.closest('[data-open]'))) { e.preventDefault(); openPanel(el.dataset.open); return; }
      if (t.closest('[data-close]') || t.id === 'scrim') { closePanel(); return; }
      if ((el = t.closest('[data-qty]'))) { el.disabled = true; KM.change(el.dataset.qty, Math.max(0, +el.dataset.q)).catch(function (err) { KM.toast(esc((err && err.description) || 'Could not update the bag')); refresh(); }); return; }
      if ((el = t.closest('[data-wish]'))) {
        e.preventDefault(); var w = el.dataset.wish, k = wish.indexOf(w);
        if (k > -1) wish.splice(k, 1); else wish.push(w);
        store.set('km_wish', wish); paintHearts();
        if (k < 0) KM.toast('Saved to your wishlist', 'View', function () { location.href = R.root.replace(/\/$/, '') + '/pages/wishlist'; });
        if (KM.onWish) KM.onWish(); return;
      }
      if ((el = t.closest('[data-add]'))) { e.preventDefault(); addFromButton(el); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
    document.addEventListener('shopify:section:load', function () { $$('[data-snap]').forEach(KM.snap); paintHearts(); });

    // footer columns: accordions on phones, open on desktop
    function ftrMode() { var open = window.innerWidth >= 900; $$('.ftr-cols details').forEach(function (d) { if (open) d.setAttribute('open', ''); }); }
    ftrMode(); window.addEventListener('resize', ftrMode);

    // announcement rotation
    var msgs = $$('.announce span'), mi = 0;
    if (msgs.length > 1 && !reduce) setInterval(function () { msgs[mi].classList.remove('on'); mi = (mi + 1) % msgs.length; msgs[mi].classList.add('on'); }, 3800);

    // measure the sticky header so bars below it dock exactly underneath
    var hs = document.querySelector('.section-header');
    function stickTop() { if (hs) document.documentElement.style.setProperty('--sticky-top', hs.offsetHeight + 'px'); }
    stickTop(); window.addEventListener('resize', stickTop);
    if (hs && 'ResizeObserver' in window) new ResizeObserver(stickTop).observe(hs);

    // desktop category menu sits beside the tall logo: links that don't fit move into "More" (Sets & Kits and Sale stay out)
    var mega = $('.mega'), more = mega && $('.mega-more', mega);
    if (more) {
      var pop = $('.mega-pop', more), mbtn = $('button', more), all = $$(':scope > a', mega);
      var shut = function () { more.classList.remove('on'); mbtn.setAttribute('aria-expanded', 'false'); };
      var fitMega = function () {
        shut();
        all.forEach(function (a) { mega.insertBefore(a, more); });
        more.hidden = true;
        if (window.innerWidth < 1000 || mega.scrollWidth <= mega.clientWidth) return;
        more.hidden = false;
        var links = all.filter(function (a) { return !a.classList.contains('sale') && !a.classList.contains('sets'); });
        while (links.length && mega.scrollWidth > mega.clientWidth) pop.insertBefore(links.pop(), pop.firstChild);
      };
      fitMega(); window.addEventListener('resize', fitMega);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitMega);
      mbtn.addEventListener('click', function (e) { e.stopPropagation(); var on = more.classList.toggle('on'); mbtn.setAttribute('aria-expanded', on ? 'true' : 'false'); });
      document.addEventListener('click', function (e) { if (!more.contains(e.target)) shut(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && more.classList.contains('on')) { shut(); mbtn.focus(); } });
    }

    // header hides on scroll down, returns on scroll up (phones and tablets)
    var hdr = $('#hdr'), last = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (hdr && window.innerWidth < 1000 && !openEl) { if (y > last + 6 && y > 220) hdr.classList.add('hide'); else if (y < last - 6) hdr.classList.remove('hide'); }
      if (hdr) document.body.classList.toggle('hdr-off', hdr.classList.contains('hide'));
      last = y;
    }, { passive: true });

    $$('[data-snap]').forEach(KM.snap);

    // countdown to the end date set on the section (default: next Sunday midnight)
    $$('[data-countdown]').forEach(function (c) {
      var fixed = c.dataset.countdown ? new Date(c.dataset.countdown) : null;
      function tick() {
        var now = new Date(), end = fixed;
        if (!end || isNaN(end) || end < now) { end = new Date(now); end.setDate(now.getDate() + ((7 - now.getDay()) % 7 || 7)); end.setHours(0, 0, 0, 0); }
        var s = Math.max(0, Math.floor((end - now) / 1000)), v = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
        Object.keys(v).forEach(function (k) { var e = $('[data-' + k + ']', c); if (e) e.textContent = k === 'd' ? v[k] : String(v[k]).padStart(2, '0'); });
      }
      tick(); setInterval(tick, 1000);
    });

    // count-up numbers
    var nums = $$('[data-count]');
    function runNum(el) { var end = +el.dataset.count, suf = el.dataset.suffix || '', t0 = performance.now(); (function f(now) { var p = Math.min(1, (now - t0) / 1100); p = 1 - Math.pow(1 - p, 3); el.textContent = Math.round(end * p) + suf; if (p < 1) requestAnimationFrame(f); })(t0); }
    if ('IntersectionObserver' in window && !reduce) { var io = new IntersectionObserver(function (es) { es.forEach(function (x) { if (x.isIntersecting) { runNum(x.target); io.unobserve(x.target); } }); }, { threshold: .5 }); nums.forEach(function (n) { io.observe(n); }); }
    else nums.forEach(function (n) { n.textContent = n.dataset.count + (n.dataset.suffix || ''); });

    // sticky bottom call-to-action appears once its trigger scrolls out of view
    $$('[data-sticky-for]').forEach(function (bar) {
      var trg = $(bar.dataset.stickyFor); if (!trg || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (es) { bar.classList.toggle('on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }).observe(trg);
    });

    // tab switcher for product grids (home bestsellers)
    $$('[data-tabs]').forEach(function (box) {
      var tabs = $$('[role=tab]', box), panels = $$('[role=tabpanel]', box);
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () {
          tabs.forEach(function (x, j) { x.setAttribute('aria-selected', j === k ? 'true' : 'false'); });
          panels.forEach(function (p, j) { p.hidden = j !== k; if (j === k) $$('.pc', p).forEach(function (c, i) { c.classList.add('fade-up'); c.style.animationDelay = (i * 40) + 'ms'; }); });
        });
      });
    });

    // recently viewed (stored as handles; cards come from the product's own JSON)
    document.dispatchEvent(new CustomEvent('km:ready'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
